module.exports = __webpack_public_path__ + "media/educator_advisory_board/Patricia_Ross-5405be92.png";